/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/blur.css';
import CookieConsent from 'react-cookie-consent';

// Components
import ProductModal from '../concepts/productModal/productModal';
import NewsletterForm from '../newsLetter/TypeFormEmbed';

// Images
import heroImage1 from '../../assets/images/homePage/zovGlobal.jpg';
import heroImage2 from '../../assets/images/homePage/kuhni.jpg';
import heroImage3 from '../../assets/images/homePage/Wardrobe.jpg';

// Project Images
import project1Img1 from '../../assets/images/projects/project1/kitchenPRINCIPAL.jpg';
import project1Img2 from '../../assets/images/projects/project1/kitchen1.jpg';
import project1Img3 from '../../assets/images/projects/project1/kitchen3.jpg';
import project1Img4 from '../../assets/images/projects/project1/kitchen4.jpg';
import project1Img5 from '../../assets/images/projects/project1/kitchen5.jpg';
import project1Img6 from '../../assets/images/projects/project1/kitchen6.jpg';
import project1Img7 from '../../assets/images/projects/project1/kitchen7.jpg';
import project1Img8 from '../../assets/images/projects/project1/kitchen8.jpg';
import project1Img9 from '../../assets/images/projects/project1/kitchen9.jpg';
import project1Img11 from '../../assets/images/projects/project1/kitchen11.jpg';

import project2Img1 from '../../assets/images/projects/project2/total3PRINCIPAL.jpg';
import project2Img2 from '../../assets/images/projects/project2/total2.jpg';
import project2Img3 from '../../assets/images/projects/project2/kitchen1.jpg';
import project2Img4 from '../../assets/images/projects/project2/kitchen2.jpg';
import project2Img5 from '../../assets/images/projects/project2/kitchen3.jpg';
import project2Img6 from '../../assets/images/projects/project2/kitchen4.jpg';
import project2Img7 from '../../assets/images/projects/project2/kitchen5.jpg';
import project2Img8 from '../../assets/images/projects/project2/kitchen6.jpg';
import project2Img9 from '../../assets/images/projects/project2/kitchen7.jpg';
import project2Img10 from '../../assets/images/projects/project2/kitchen8.jpg';
import project2Img11 from '../../assets/images/projects/project2/dressing1.jpg';
import project2Img12 from '../../assets/images/projects/project2/dressing2.jpg';
import project2Img13 from '../../assets/images/projects/project2/dessing3.jpg';
import project2Img14 from '../../assets/images/projects/project2/dressing4.jpg';
import project2Img15 from '../../assets/images/projects/project2/dressing5.jpg';
import project2Img16 from '../../assets/images/projects/project2/space1.jpg';
import project2Img17 from '../../assets/images/projects/project2/space2.jpg';
import project2Img18 from '../../assets/images/projects/project2/space3.jpg';

// Constants - Updated Design System
const PRIMARY_COLOR = '#0a1628'; // Deep Navy
const PRIMARY_DARK = '#050a12';
const ACCENT_COLOR = '#c9a962'; // Elegant Gold
const TEXT_LIGHT = '#ffffff';
const TEXT_DARK = '#1a1a2e';
const TEXT_MUTED = '#6c757d';
const BG_LIGHT = '#f8f9fa';
const FONT_PRIMARY = "'Inter', sans-serif";
const FONT_SECONDARY = "'Cormorant Garamond', serif";

// Styles
const styles = {
  // Global
  homePage: {
    fontFamily: FONT_PRIMARY,
    color: TEXT_DARK,
    backgroundColor: BG_LIGHT,
    overflowX: 'hidden',
  },
  headerSpacer: {
    height: '0px',
  },

  // Text and Titles
  sectionTitle: {
    fontFamily: FONT_SECONDARY,
    fontSize: '3rem',
    fontWeight: 500,
    marginBottom: '16px',
    lineHeight: 1.2,
    color: TEXT_DARK,
    textAlign: 'center',
  },
  sectionTitleLight: {
    fontFamily: FONT_SECONDARY,
    fontSize: '3rem',
    fontWeight: 500,
    marginBottom: '16px',
    lineHeight: 1.2,
    color: TEXT_LIGHT,
    textAlign: 'center',
  },
  sectionSubtitle: {
    display: 'inline-block',
    fontFamily: FONT_PRIMARY,
    fontSize: '1rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '3px',
    color: ACCENT_COLOR,
    marginBottom: '16px',
  },

  // Buttons
  btnPrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 32px',
    backgroundColor: ACCENT_COLOR,
    color: PRIMARY_COLOR,
    fontFamily: FONT_PRIMARY,
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
    textDecoration: 'none',
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1,
    whiteSpace: 'nowrap',
    minWidth: 'fit-content',
  },
  btnSecondary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px 32px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: TEXT_LIGHT,
    fontFamily: FONT_PRIMARY,
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
    textDecoration: 'none',
    marginLeft: '15px',
    whiteSpace: 'nowrap',
    minWidth: 'fit-content',
    backdropFilter: 'blur(10px)',
  },
  btnText: {
    display: 'inline-flex',
    alignItems: 'center',
    color: ACCENT_COLOR,
    fontFamily: FONT_PRIMARY,
    fontSize: '15px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    cursor: 'pointer',
    transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
    textDecoration: 'none',
  },

  // Common layouts
  sectionCommon: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '120px 0',
    boxSizing: 'border-box',
    position: 'relative',
    left: '0',
    right: '0',
    overflow: 'hidden',
  },
  sectionContent: {
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '0 40px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionHeader: {
    width: '100%',
    textAlign: 'center',
    marginBottom: '60px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  heroSection: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    minHeight: '700px',
    overflow: 'hidden',
    backgroundColor: PRIMARY_DARK,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  heroSlidesContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  heroSlide: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: 1,
  },
  heroImageWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden',
  },
  heroImageOverlay: {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(to right, rgba(5, 10, 18, 0.85) 0%, rgba(10, 22, 40, 0.6) 50%, rgba(10, 22, 40, 0.4) 100%)',
    zIndex: 1,
  },
  heroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transformOrigin: 'center',
    filter: 'brightness(0.9)',
  },
  heroContent: {
    position: 'relative',
    maxWidth: '600px',
    padding: '0 5%',
    marginLeft: '5%',
    zIndex: 2,
    color: TEXT_LIGHT,
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    lineHeight: 1.1,
    color: TEXT_LIGHT,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    fontWeight: 400,
    marginBottom: '2rem',
    color: 'rgba(255, 255, 255, 0.9)',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
  },
  heroButtons: {
    display: 'flex',
    gap: '1rem',
    marginTop: '2rem',
  },
  heroControls: {
    position: 'absolute',
    bottom: '40px',
    left: '0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 5,
    padding: '0',
  },
  heroArrow: {
    background: 'rgba(201, 169, 98, 0.15)',
    border: '1px solid rgba(201, 169, 98, 0.4)',
    color: TEXT_LIGHT,
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    margin: '0 20px',
  },
  heroIndicators: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
  },
  indicator: {
    width: '40px',
    height: '3px',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: '0',
  },
  indicatorActive: {
    backgroundColor: ACCENT_COLOR,
    boxShadow: '0 0 10px rgba(212, 175, 55, 0.5)',
  },
  projectsGrid: {
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '0 40px',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
  },
  servicesGrid: {
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '0 40px',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '30px',
  },
  testimonialsGrid: {
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '0 40px',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
  },
  ctaSection: {
    background: 'linear-gradient(rgba(10, 22, 40, 0.95), rgba(10, 22, 40, 0.95))',
    width: '100%',
    padding: '120px 0',
    color: TEXT_LIGHT,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  ctaContent: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  ctaTitle: {
    fontFamily: FONT_SECONDARY,
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: '20px',
    color: TEXT_LIGHT,
    textAlign: 'center',
    width: '100%',
  },
  ctaText: {
    fontSize: '1.2rem',
    lineHeight: 1.7,
    marginBottom: '40px',
    color: 'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    width: '100%',
  },
  ctaButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    width: '100%',
  },
  projectCard: {
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
    cursor: 'pointer',
    width: '100%',
  },
  serviceCard: {
    padding: '40px 20px',
    textAlign: 'center',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    transition: 'all 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  testimonialCard: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '4px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  mobileStyles: {
    sectionTitle: {
      fontSize: '2.25rem',
    },
    sectionContent: {
      padding: '0 20px',
    },
    sectionCommon: {
      padding: '80px 15px',
    },
    headerSpacer: {
      height: '80px',
    },
    btnPrimary: {
      width: 'auto',
      minWidth: '200px',
      maxWidth: '280px',
      textAlign: 'center',
      margin: '0 auto',
      display: 'inline-flex',
      boxSizing: 'border-box',
      padding: '14px 24px',
      fontSize: '12px',
    },
    btnSecondary: {
      marginLeft: 0,
      marginTop: '12px',
      display: 'inline-flex',
      width: 'auto',
      minWidth: '200px',
      maxWidth: '280px',
      margin: '12px auto 0',
      textAlign: 'center',
      boxSizing: 'border-box',
      padding: '13px 24px',
      fontSize: '12px',
    },

    // Hero mobile
    heroSection: {
      height: '90vh',
    },
    heroSlide: {
      justifyContent: 'center',
      textAlign: 'center',
    },
    heroImageOverlay: {
      background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 100%)',
    },
    heroContent: {
      maxWidth: '100%',
      width: '90%',
      margin: '0 auto',
      padding: 0,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginLeft: 0,
    },
    heroTitle: {
      fontSize: '2.2rem',
      textAlign: 'center',
    },
    heroSubtitle: {
      fontSize: '1.1rem',
      textAlign: 'center',
    },
    heroButtons: {
      flexDirection: 'column',
      width: '100%',
      gap: '0.8rem',
      alignItems: 'center',
    },
    heroControls: {
      bottom: '20px',
      flexWrap: 'wrap',
      justifyContent: 'center',
      padding: 0,
    },
    heroArrow: {
      display: 'none',
    },
    heroIndicators: {
      width: '100%',
      justifyContent: 'center',
      marginBottom: '12px',
    },
    indicator: {
      width: '24px',
      height: '2px',
    },

    // Grids mobile
    projectsGrid: {
      gridTemplateColumns: '1fr',
      padding: '0 15px',
      maxWidth: '100%',
    },
    servicesGrid: {
      gridTemplateColumns: '1fr',
      padding: '0 15px',
      maxWidth: '100%',
    },
    testimonialsGrid: {
      gridTemplateColumns: '1fr',
      padding: '0 15px',
      maxWidth: '100%',
    },

    // Cards mobile
    projectCard: {
      maxWidth: '100%',
      margin: '0 auto',
    },
    projectImageContainer: {
      height: '280px',
    },
    projectInfo: {
      padding: '20px',
      textAlign: 'center',
    },
    projectTitle: {
      fontSize: '1.4rem',
    },
    serviceCard: {
      padding: '30px 20px',
      maxWidth: '100%',
    },
    testimonialCard: {
      padding: '30px 20px',
      maxWidth: '100%',
    },
    testimonialText: {
      fontSize: '1rem',
    },

    // CTA mobile
    ctaSection: {
      padding: '80px 15px',
    },
    ctaContent: {
      padding: '0 15px',
      width: '100%',
    },
    ctaTitle: {
      fontSize: '2.5rem',
      width: '100%',
    },
    ctaText: {
      fontSize: '1.1rem',
      width: '100%',
    },
    ctaButtons: {
      flexDirection: 'column',
      width: '100%',
    },
    buttonPrimary: {
      width: '100%',
      margin: '0 0 15px 0',
      boxSizing: 'border-box',
    },
    buttonSecondary: {
      width: '100%',
      margin: '0',
      boxSizing: 'border-box',
    }
  },
  // Intro section
  introSection: {
    backgroundColor: TEXT_LIGHT,
    position: 'relative',
  },
  introContent: {
    maxWidth: '800px',
    textAlign: 'center',
  },
  introText: {
    fontSize: '1.2rem',
    lineHeight: 1.8,
    color: TEXT_MUTED,
    marginBottom: '40px',
  },
  signatureLine: {
    width: '100px',
    height: '2px',
    backgroundColor: ACCENT_COLOR,
    margin: '50px auto 0',
  },

  // Projects section
  projectsSection: {
    backgroundColor: '#f7f7f7',
  },
  projectImageContainer: {
    position: 'relative',
    overflow: 'hidden',
    height: '350px',
  },
  projectImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 1.5s cubic-bezier(0.165, 0.84, 0.44, 1)',
  },
  projectOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(to bottom, rgba(28, 34, 64, 0.3), rgba(28, 34, 64, 0.8))',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0,
    transition: 'all 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)',
  },
  projectCategory: {
    position: 'absolute',
    top: '20px',
    left: '20px',
    backgroundColor: ACCENT_COLOR,
    color: PRIMARY_COLOR,
    padding: '8px 16px',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  viewProjectBtn: {
    backgroundColor: 'transparent',
    border: `2px solid ${TEXT_LIGHT}`,
    color: TEXT_LIGHT,
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    cursor: 'pointer',
    transition: 'all 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)',
    transform: 'translateY(20px)',
    opacity: 0,
  },
  projectInfo: {
    padding: '30px',
  },
  projectTitle: {
    fontFamily: FONT_SECONDARY,
    fontSize: '1.6rem',
    fontWeight: 600,
    marginBottom: '15px',
    color: TEXT_DARK,
  },
  projectDescription: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: TEXT_MUTED,
  },
  projectsCta: {
    textAlign: 'center',
    marginTop: '60px',
    width: '100%',
  },
  // Services section
  servicesSection: {
    backgroundColor: PRIMARY_COLOR,
    color: TEXT_LIGHT,
  },
  serviceIcon: {
    fontSize: '2rem',
    marginBottom: '20px',
    color: ACCENT_COLOR,
  },
  serviceTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginBottom: '15px',
    color: TEXT_LIGHT,
  },
  serviceDescription: {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: 'rgba(255, 255, 255, 0.8)',
  },

  // Testimonials section
  testimonialsSection: {
    backgroundColor: '#f8f8f8',
  },
  testimonialRating: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
  },
  star: {
    fontSize: '1.2rem',
    color: '#ccc',
    marginRight: '5px',
  },
  starFilled: {
    fontSize: '1.2rem',
    color: ACCENT_COLOR,
    marginRight: '5px',
  },
  authorName: {
    fontFamily: FONT_SECONDARY,
    fontSize: '1.2rem',
    fontWeight: 600,
    marginBottom: '5px',
    color: TEXT_DARK,
  },
  authorPosition: {
    fontSize: '0.9rem',
    color: TEXT_MUTED,
  },
};

// Testimonials data (names kept original, positions translated in component)
const testimonialsData = [
  {
    id: 1,
    name: 'Olga Zukhovitskaya',
    positionKey: 'villaOwner',
    text: 'If you would like to enjoy excellent customer service or just to drink a cup of coffee while discussing your future design project, you are at the right place for sure! Our kitchen designer was extremely patient and flexible with us. We had non-standard layout and were looking for some extraordinary solution. They really have a huge choice of everything you might dream of. As a result we love our kitchen so much! Well done, guys! Strongly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Людмила Белоус',
    positionKey: 'kitchenOwner',
    text: 'Выражаю огромную благодарность сотрудникам фирмы Zov Furniture LLC , которые успешно выполнили мой индивидуальный заказ на кухонный гарнитур в соответствии с моими пожеланиями ( форма, размер, цвет, подбор материалов и оборудования, вместимость , удобство в эксплуатации)! И мне очень понравились внимание, доброжелательность, легкость в общении , и , самое главное, их высокий профессионализм на всех этапах рабочего процесса! И пусть будет расти объем вашей деятельности во всех аспектах и количество благодарных вам клиентов!',
    rating: 5
  },
  {
    id: 3,
    name: 'Florent B.',
    positionKey: 'propertyDeveloper',
    text: 'I recently visited Zov Furniture to check out their kitchen furniture and was thoroughly impressed with the quality on offer. The craftsmanship of the units is exceptional, with a keen attention to detail that\'s evident in every piece. What stood out to me the most was the incredible value for money — it\'s not often you find such high-quality kitchens at such reasonable prices. The store\'s selection struck the perfect balance between luxury and affordability. Highly recommend for anyone in the market for new kitchen furniture.',
    rating: 5
  },
];

function HomePage() {
  const { t, i18n } = useTranslation();
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentHeroSlide, setCurrentHeroSlide] = useState(0);
  const autoSlideRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const isRTL = i18n.language === 'ar';

  // Translated hero slides
  const heroSlides = [
    {
      image: heroImage1,
      title: t('hero.slide1Title'),
      subtitle: t('hero.slide1Subtitle')
    },
    {
      image: heroImage2,
      title: t('hero.slide2Title'),
      subtitle: t('hero.slide2Subtitle')
    },
    {
      image: heroImage3,
      title: t('hero.slide3Title'),
      subtitle: t('hero.slide3Subtitle')
    }
  ];

  // Translated featured projects
  const featuredProjects = [
    {
      id: 1,
      title: t('projects.project1Title'),
      category: t('projects.project1Category'),
      previewUrl: project1Img1,
      imageUrls: [project1Img1, project1Img2, project1Img3, project1Img4, project1Img5, project1Img6, project1Img7, project1Img8, project1Img9, project1Img11],
      description: t('projects.project1Desc'),
      features: [t('projects.customCabinetry'), t('projects.integratedAppliances')]
    },
    {
      id: 2,
      title: t('projects.project2Title'),
      category: t('projects.project2Category'),
      previewUrl: project2Img1,
      imageUrls: [project2Img1, project2Img2, project2Img3, project2Img4, project2Img5, project2Img6, project2Img7, project2Img8, project2Img9, project2Img10, project2Img11, project2Img12, project2Img13, project2Img14, project2Img15, project2Img16, project2Img17, project2Img18],
      description: t('projects.project2Desc'),
      features: [t('projects.customFurniture'), t('projects.designerLighting'), t('projects.customWallTreatments')]
    }
  ];

  // Translated services
  const services = [
    {
      title: t('home.bespokeDesign'),
      description: t('home.bespokeDesignDesc'),
      icon: '✓'
    },
    {
      title: t('home.whiteGloveDelivery'),
      description: t('home.whiteGloveDeliveryDesc'),
      icon: '✓'
    },
    {
      title: t('home.professionalInstallation'),
      description: t('home.professionalInstallationDesc'),
      icon: '✓'
    },
    {
      title: t('home.lifetimeWarranty'),
      description: t('home.lifetimeWarrantyDesc'),
      icon: '✓'
    },
  ];

  // Check if device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      const mobileWidth = 768;
      const currentWidth = window.innerWidth;
      setIsMobile(currentWidth <= mobileWidth);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  useEffect(() => {
    autoSlideRef.current = setInterval(() => {
      setCurrentHeroSlide((prev) => (prev + 1) % heroSlides.length);
    }, 7000);

    return () => {
      if (autoSlideRef.current) clearInterval(autoSlideRef.current);
    };
  }, []);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  const handleSlideChange = (index) => {
    if (index !== currentHeroSlide) {
      // Reset the interval timer when manually changing slides
      if (autoSlideRef.current) clearInterval(autoSlideRef.current);
      setCurrentHeroSlide(index);
      autoSlideRef.current = setInterval(() => {
        setCurrentHeroSlide((prev) => (prev + 1) % heroSlides.length);
      }, 7000);
    }
  };

  // Slide variants for animation - adjust for mobile
  const slideVariants = {
    enter: (direction) => ({
      x: isMobile ? 0 : (direction > 0 ? '100%' : '-100%'),
      y: isMobile ? '30px' : 0,
      opacity: 0,
      scale: isMobile ? 0.95 : 1.05,
    }),
    center: {
      x: 0,
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        x: { type: 'tween', duration: isMobile ? 0.3 : 0.8, ease: [0.16, 1, 0.3, 1] },
        y: { type: 'tween', duration: isMobile ? 0.3 : 0.8, ease: [0.16, 1, 0.3, 1] },
        opacity: { duration: 0.5, ease: 'easeInOut' },
        scale: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
      },
    },
    exit: (direction) => ({
      x: isMobile ? 0 : (direction < 0 ? '100%' : '-100%'),
      y: isMobile ? '-30px' : 0,
      opacity: 0,
      scale: isMobile ? 0.95 : 0.95,
      transition: {
        x: { type: 'tween', duration: isMobile ? 0.3 : 0.8, ease: [0.16, 1, 0.3, 1] },
        y: { type: 'tween', duration: isMobile ? 0.3 : 0.8, ease: [0.16, 1, 0.3, 1] },
        opacity: { duration: 0.5, ease: 'easeInOut' },
        scale: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
      },
    }),
  };

  // Calculate the direction of slide change for animation
  const [slideDirection, setSlideDirection] = useState(1);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        setSlideDirection(-1);
        handleSlideChange((currentHeroSlide - 1 + heroSlides.length) % heroSlides.length);
      }
      else if (e.key === 'ArrowRight') {
        setSlideDirection(1);
        handleSlideChange((currentHeroSlide + 1) % heroSlides.length);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentHeroSlide]);

  return (
    <>
      <Helmet>
        <title>ZOV Furniture | Luxury Kitchens Abu Dhabi | أثاث فاخر | Элитная мебель ОАЭ</title>
        <meta name="description" content="Premium luxury furniture showroom in Abu Dhabi, UAE. Bespoke kitchens, wardrobes & interior solutions. ISO certified. +971 50 963 6346 | اكتشف زوف للأثاث الفاخر | Элитная мебель и кухни на заказ в Абу-Даби" />
        <meta name="keywords" content="luxury furniture Abu Dhabi, custom kitchens UAE, bespoke wardrobes Dubai, premium furniture showroom, interior design Abu Dhabi, ZOV furniture, أثاث فاخر أبوظبي, مطابخ فاخرة, элитная мебель Абу-Даби, кухни на заказ ОАЭ, мебель премиум класса Дубай, шкафы-купе ОАЭ" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://zov.ae/" />
        <link rel="alternate" hrefLang="en" href="https://zov.ae/" />
        <link rel="alternate" hrefLang="ar" href="https://zov.ae/ar/" />
        <link rel="alternate" hrefLang="ru" href="https://zov.ae/ru/" />
        <meta property="og:title" content="ZOV Furniture | Luxury Kitchens & Furniture Abu Dhabi" />
        <meta property="og:description" content="Premium luxury furniture showroom in Abu Dhabi. Custom kitchens, wardrobes & interior solutions. ISO certified." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://zov.ae/" />
        <meta property="og:image" content="https://zov.ae/og-image.jpg" />
        <meta property="og:site_name" content="ZOV Furniture" />
        <meta property="og:locale" content="en_AE" />
        <meta property="og:locale:alternate" content="ar_AE" />
        <meta property="og:locale:alternate" content="ru_RU" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ZOV Furniture | Luxury Furniture Abu Dhabi" />
        <meta name="twitter:description" content="Premium luxury furniture & bespoke kitchens in Abu Dhabi, UAE." />
        <meta name="twitter:image" content="https://zov.ae/og-image.jpg" />
      </Helmet>

      <div style={{ ...styles.homePage, overflow: 'hidden' }}>
        {/* Hero Section */}
        <section
          className="hero-section"
          style={{
            ...(isMobile ? { ...styles.heroSection, ...styles.mobileStyles.heroSection } : styles.heroSection)
          }}
        >
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <AnimatePresence initial={false} custom={slideDirection} mode="sync">
              <motion.div
                key={currentHeroSlide}
                custom={slideDirection}
                variants={slideVariants}
                initial="enter"
                animate="center"
                exit="exit"
                style={{
                  width: '100%',
                  height: '100%',
                  ...(isMobile ? { ...styles.heroSlide, ...styles.mobileStyles.heroSlide } : styles.heroSlide)
                }}
              >
                <div style={styles.heroImageWrapper}>
                  <div style={isMobile ? styles.mobileStyles.heroImageOverlay : styles.heroImageOverlay} />
                  <LazyLoadImage
                    src={heroSlides[currentHeroSlide].image}
                    alt={heroSlides[currentHeroSlide].title}
                    effect="blur"
                    style={styles.heroImage}
                    width="100%"
                    height="100%"
                    placeholderSrc={heroSlides[currentHeroSlide].image}
                  />
                </div>
                <div style={isMobile ? { ...styles.heroContent, ...styles.mobileStyles.heroContent } : styles.heroContent}>
                  <motion.h1
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    style={isMobile ? { ...styles.heroTitle, ...styles.mobileStyles.heroTitle } : styles.heroTitle}
                  >
                    {heroSlides[currentHeroSlide].title}
                  </motion.h1>
                  <motion.p
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    style={isMobile ? { ...styles.heroSubtitle, ...styles.mobileStyles.heroSubtitle } : styles.heroSubtitle}
                  >
                    {heroSlides[currentHeroSlide].subtitle}
                  </motion.p>
                  <motion.div
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.7, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                  >
                    <NewsletterForm />
                    <div style={isMobile ? { ...styles.heroButtons, ...styles.mobileStyles.heroButtons } : styles.heroButtons}>
                      <a
                        href="/concepts"
                        style={isMobile ? { ...styles.btnPrimary, ...styles.mobileStyles.btnPrimary } : styles.btnPrimary}
                      >
                        {t('hero.exploreCollection')}
                      </a>
                      <a
                        href="/contact"
                        style={isMobile ? { ...styles.btnSecondary, ...styles.mobileStyles.btnSecondary } : styles.btnSecondary}
                      >
                        {t('hero.bookConsultation')}
                      </a>
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div style={isMobile ? { ...styles.heroControls, ...styles.mobileStyles.heroControls } : styles.heroControls}>
            <button
              style={isMobile ? { ...styles.heroArrow, ...styles.mobileStyles.heroArrow } : styles.heroArrow}
              onClick={() => {
                setSlideDirection(-1);
                handleSlideChange((currentHeroSlide - 1 + heroSlides.length) % heroSlides.length);
              }}
              aria-label="Previous slide"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <div style={isMobile ? { ...styles.heroIndicators, ...styles.mobileStyles.heroIndicators } : styles.heroIndicators}>
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  style={{
                    ...(isMobile ? { ...styles.indicator, ...styles.mobileStyles.indicator } : styles.indicator),
                    ...(index === currentHeroSlide ? styles.indicatorActive : {})
                  }}
                  onClick={() => {
                    setSlideDirection(index > currentHeroSlide ? 1 : -1);
                    handleSlideChange(index);
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            <button
              style={isMobile ? { ...styles.heroArrow, ...styles.mobileStyles.heroArrow } : styles.heroArrow}
              onClick={() => {
                setSlideDirection(1);
                handleSlideChange((currentHeroSlide + 1) % heroSlides.length);
              }}
              aria-label="Next slide"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </section>

        {/* Introduction Section */}
        <section
          style={{
            ...styles.sectionCommon,
            ...styles.introSection,
            ...(isMobile && styles.mobileStyles.sectionCommon)
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            style={{
              ...styles.sectionContent,
              ...styles.introContent,
              ...(isMobile && styles.mobileStyles.sectionContent)
            }}
          >
            <span style={styles.sectionSubtitle}>{t('home.exclusivityRedefined')}</span>
            <h2 style={isMobile ? { ...styles.sectionTitle, ...styles.mobileStyles.sectionTitle } : styles.sectionTitle}>{t('home.handcraftedLuxury')}</h2>
            <p style={styles.introText}>
              {t('home.introText')}
            </p>
            <a href="/about" style={styles.btnText}>
              {t('home.discoverLegacy')} <span style={{ marginLeft: isRTL ? '0' : '10px', marginRight: isRTL ? '10px' : '0', transition: 'transform 0.3s ease' }}>{isRTL ? '←' : '→'}</span>
            </a>
          </motion.div>
          <div style={styles.signatureLine} />
        </section>

        {/* Featured Projects Section */}
        <section
          style={{
            ...styles.sectionCommon,
            ...styles.projectsSection,
            ...(isMobile && styles.mobileStyles.sectionCommon)
          }}
          id="projects"
        >
          <div style={styles.sectionHeader}>
            <span style={styles.sectionSubtitle}>{t('home.portfolioTitle')}</span>
            <h2 style={isMobile ? { ...styles.sectionTitle, ...styles.mobileStyles.sectionTitle } : styles.sectionTitle}>{t('home.featuredProjects')}</h2>
          </div>
          <div
            style={isMobile ? { ...styles.projectsGrid, ...styles.mobileStyles.projectsGrid } : styles.projectsGrid}
          >
            {featuredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                onClick={() => handleProjectClick(project)}
                style={isMobile ? { ...styles.projectCard, ...styles.mobileStyles.projectCard } : styles.projectCard}
              >
                <div style={isMobile ? { ...styles.projectImageContainer, ...styles.mobileStyles.projectImageContainer } : styles.projectImageContainer}>
                  <LazyLoadImage
                    src={project.previewUrl}
                    alt={project.title}
                    effect="blur"
                    style={styles.projectImage}
                    width="100%"
                    height="100%"
                    placeholderSrc={project.previewUrl}
                  />
                  <div style={styles.projectOverlay}>
                    <span style={styles.projectCategory}>{project.category}</span>
                    <button style={styles.viewProjectBtn}>{t('home.viewProject')}</button>
                  </div>
                </div>
                <div style={isMobile ? { ...styles.projectInfo, ...styles.mobileStyles.projectInfo } : styles.projectInfo}>
                  <h3 style={isMobile ? { ...styles.projectTitle, ...styles.mobileStyles.projectTitle } : styles.projectTitle}>{project.title}</h3>
                  <p style={styles.projectDescription}>{project.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
          <div style={styles.projectsCta}>
            <a
              href="/portfolio"
              style={isMobile ? { ...styles.btnPrimary, ...styles.mobileStyles.btnPrimary } : styles.btnPrimary}
            >
              {t('home.viewAllProjects')}
            </a>
          </div>
        </section>

        {/* Services Section */}
        <section
          style={{
            ...styles.sectionCommon,
            ...styles.servicesSection,
            ...(isMobile && styles.mobileStyles.sectionCommon)
          }}
        >
          <div style={styles.sectionHeader}>
            <span style={styles.sectionSubtitle}>{t('home.ourPromise')}</span>
            <h2 style={isMobile ? { ...styles.sectionTitleLight, ...styles.mobileStyles.sectionTitle } : styles.sectionTitleLight}>{t('home.exceptionalServices')}</h2>
          </div>
          <div
            style={isMobile ? { ...styles.servicesGrid, ...styles.mobileStyles.servicesGrid } : styles.servicesGrid}
          >
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                style={isMobile ? { ...styles.serviceCard, ...styles.mobileStyles.serviceCard } : styles.serviceCard}
              >
                <div style={styles.serviceIcon}>{service.icon}</div>
                <h3 style={styles.serviceTitle}>{service.title}</h3>
                <p style={styles.serviceDescription}>{service.description}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Testimonials Section */}
        <section
          style={{
            ...styles.sectionCommon,
            ...styles.testimonialsSection,
            ...(isMobile && styles.mobileStyles.sectionCommon)
          }}
        >
          <div style={styles.sectionHeader}>
            <span style={styles.sectionSubtitle}>{t('home.clientExperiences')}</span>
            <h2 style={isMobile ? { ...styles.sectionTitle, ...styles.mobileStyles.sectionTitle } : styles.sectionTitle}>{t('home.testimonials')}</h2>
          </div>
          <div
            style={isMobile ? { ...styles.testimonialsGrid, ...styles.mobileStyles.testimonialsGrid } : styles.testimonialsGrid}
          >
            {testimonialsData.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                style={isMobile ? { ...styles.testimonialCard, ...styles.mobileStyles.testimonialCard } : styles.testimonialCard}
              >
                <div style={styles.testimonialRating}>
                  {Array.from({ length: 5 }, (_, i) => (
                    <span key={i} style={i < testimonial.rating ? styles.starFilled : styles.star}>★</span>
                  ))}
                </div>
                <p style={isMobile ? { ...styles.testimonialText, ...styles.mobileStyles.testimonialText } : styles.testimonialText}>"{testimonial.text}"</p>
                <div>
                  <h4 style={styles.authorName}>{testimonial.name}</h4>
                  <p style={styles.authorPosition}>{t(`testimonials.${testimonial.positionKey}`)}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Call to Action Section */}
        <section
          style={{
            ...styles.ctaSection,
            ...(isMobile && styles.mobileStyles.ctaSection)
          }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            style={{
              ...styles.ctaContent,
              ...(isMobile && styles.mobileStyles.ctaContent)
            }}
          >
            <h2
              style={{
                ...styles.ctaTitle,
                ...(isMobile && styles.mobileStyles.ctaTitle)
              }}
            >
              {t('home.transformSpace')}
            </h2>
            <p
              style={{
                ...styles.ctaText,
                ...(isMobile && styles.mobileStyles.ctaText)
              }}
            >
              {t('home.ctaText')}
            </p>
            <div
              style={{
                ...styles.ctaButtons,
                ...(isMobile && styles.mobileStyles.ctaButtons)
              }}
            >
              <a
                href="/location"
                style={isMobile ? { ...styles.btnPrimary, ...styles.mobileStyles.buttonPrimary } : styles.btnPrimary}
              >
                {t('home.visitShowroom')}
              </a>
              <a
                href="/contact"
                style={isMobile ? { ...styles.btnSecondary, ...styles.mobileStyles.buttonSecondary } : styles.btnSecondary}
              >
                {t('home.contactUs')}
              </a>
            </div>
          </motion.div>
        </section>

        {/* Cookie Consent */}
        <CookieConsent
          location="bottom"
          buttonText={t('common.accept')}
          cookieName="userConsent"
          style={{
            background: 'rgba(28, 34, 64, 0.95)',
            boxShadow: '0 -10px 20px rgba(0, 0, 0, 0.1)',
            padding: '16px 24px',
            alignItems: 'center',
            fontFamily: FONT_PRIMARY,
            maxWidth: '100%',
            zIndex: 9999,
            direction: isRTL ? 'rtl' : 'ltr',
          }}
          buttonStyle={{
            color: PRIMARY_COLOR,
            fontSize: '14px',
            background: ACCENT_COLOR,
            padding: '10px 24px',
            borderRadius: '2px',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            margin: '10px 0 0 0',
          }}
          contentStyle={{
            flex: '1 0 100%',
            margin: '0 0 10px 0',
          }}
          expires={150}
          onDecline={() => {
            // Handle decline if needed
          }}
        >
          {t('home.cookieMessage')}{' '}
          <a href="/privacy-policy" style={{ color: ACCENT_COLOR, textDecoration: 'underline', marginLeft: isRTL ? '0' : '5px', marginRight: isRTL ? '5px' : '0' }}>
            {t('common.privacyPolicy')}
          </a>
        </CookieConsent>

        {/* Product Modal */}
        {isModalOpen && <ProductModal product={selectedProject} onClose={handleCloseModal} />}
      </div>
    </>
  );
}

export default React.memo(HomePage);
